import { Corporations } from "./Corporations";
import { useStyles } from "./OsornoSetupDashboard.styles";

export const OsornoSetupDashboard = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Corporations />
        </div>
    );
};
